"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var string_1 = require("./string");

exports.objectIsEmpty = function (object) {
  return !object || Object.keys(object).length === 0 && object.constructor === Object;
};

exports.findKey = function (object, predicate) {
  var result;
  if (object == null) return result;
  Object.keys(object).some(function (key) {
    var value = object[key];

    if (predicate(value, key, object)) {
      result = key;
      return true;
    }
  });
  return result;
};

exports.objectKeysToCamel = function (object) {
  var camelKeyObject = {};
  Object.keys(object).forEach(function (key) {
    camelKeyObject[string_1.toCamel(key)] = object[key];
  });
  return camelKeyObject;
};

var OBJECT_UTILS = {
  objectIsEmpty: exports.objectIsEmpty,
  findKey: exports.findKey,
  objectKeysToCamel: exports.objectKeysToCamel
};
exports.default = OBJECT_UTILS;